// Build a lookup that resolves a placement's thumbnail by numeric page index (Large Format)
// OR by size label "WxH" (Stickers, whose placements carry page=null).
export function buildThumbsByKey(pageThumbs, sizes) {
  const m = { ...(pageThumbs || {}) };
  (sizes || []).forEach((s) => {
    const t = (s.page != null && pageThumbs) ? pageThumbs[s.page] : null;
    if (t) m[`${+s.width}x${+s.height}`] = t;
  });
  return m;
}

const thumbKey = (p) => (p.page != null ? p.page : p.label);

// Rasterize the sheet layout with the real logos placed on it → a light JPEG Blob (preview quality).
export async function renderMockupBlob(layout, thumbsByKey) {
  if (!layout || !layout.placements || !layout.placements.length) return null;
  const { bin_width, used_length, placements, sheet_height } = layout;
  const W = 700;
  const scale = W / (bin_width || 1);
  const GAP = sheet_height ? 24 : 0;
  const secH = sheet_height ? sheet_height * scale : 0;
  const secs = sheet_height ? Math.max(1, Math.round((used_length || sheet_height) / sheet_height)) : 0;
  const H = sheet_height
    ? Math.round(secs * secH + (secs - 1) * GAP + 4)
    : Math.max(Math.round((used_length || 1) * scale), 40);
  const cv = document.createElement("canvas");
  cv.width = W; cv.height = H;
  const ctx = cv.getContext("2d");
  ctx.fillStyle = "#F8FAFC"; ctx.fillRect(0, 0, W, H);
  const sy = (y) => {
    if (!sheet_height) return y * scale;
    const s = Math.floor((y + 0.001) / sheet_height);
    return s * (secH + GAP) + (y - s * sheet_height) * scale;
  };
  if (sheet_height) {
    for (let s = 0; s < secs; s++) {
      const top = s * (secH + GAP);
      ctx.fillStyle = "#FFFFFF"; ctx.fillRect(0.5, top + 0.5, W - 1, secH - 1);
      ctx.strokeStyle = "#94A3B8"; ctx.lineWidth = 1; ctx.strokeRect(0.5, top + 0.5, W - 1, secH - 1);
    }
  }
  const keys = [...new Set(placements.map(thumbKey))];
  const imgs = {};
  await Promise.all(keys.map((k) => new Promise((res) => {
    const u = thumbsByKey[k];
    if (!u) return res();
    const im = new Image();
    im.onload = () => { imgs[k] = im; res(); };
    im.onerror = () => res();
    im.src = u;
  })));
  placements.forEach((p) => {
    const key = thumbKey(p);
    const px = p.x * scale, py = sy(p.y), pw = p.w * scale, ph = p.h * scale;
    const im = imgs[key];
    if (im && im.width && im.height) {
      const r = Math.min(pw / im.width, ph / im.height);
      const dw = im.width * r, dh = im.height * r;
      ctx.drawImage(im, px + (pw - dw) / 2, py + (ph - dh) / 2, dw, dh);
      ctx.strokeStyle = "rgba(10,10,10,0.30)"; ctx.lineWidth = 1; ctx.strokeRect(px, py, pw, ph);
    } else {
      ctx.fillStyle = "rgba(36,149,211,0.18)"; ctx.fillRect(px, py, pw, ph);
      ctx.strokeStyle = "#2495D3"; ctx.lineWidth = 1; ctx.strokeRect(px, py, pw, ph);
    }
  });
  return await new Promise((res) => cv.toBlob((b) => res(b), "image/jpeg", 0.72));
}
